module.exports = __webpack_public_path__ + "static/img/imgWeather.baa4d8f1.webp";